/** Pictographs for tight bars; every button using one also carries a translated accessible name. */
export const GLYPH = { undo: '↶', search: '⌕' } as const;
